import React from 'react';
import { CollapseFAQ, H3, LayoutSingleColumn, NamedLink, Page } from '../../components';
import SectionFooter from '../PageBuilder/SectionBuilder/SectionFooter';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import PublicGardenImage from './images/London - Public front garden.jpg'
import ArgyllScotlandImage from './images/ARGYLL Scotland.jpg';
import LondonWestminsterImage from './images/Pete - UK Staycation - London Westminster at sunset.jpg';
import css from './HouseSittingUK.module.css';
import SectionHero from '../../components/StaticPageContainers/SectionHero';
import ContinueIcon from '../TopbarContainer/Topbar/images/continue-icon.svg';
import { userTypes } from '../../util/userTypes';
import SectionGrid421 from '../../components/StaticPageContainers/SectionGrid421';
import RatedImage from './images/rated_image.png';
import SafeImage from './images/safe_image.png';
import PersonalImage from './images/personal_image.png';
import UkImage from './images/uk_image.png';
import AvatarPlaceholder from './images/avatar_placeholder.png';

import WalesImage from './images/wales.png';
import ScotlandImage from './images/scotland.png';
import IrelandImage from './images/northern_ireland.png';
import EnglandImage from './images/england.png';
import SectionGrid21 from '../../components/StaticPageContainers/SectionGrid21';
import SectionGrid41 from '../../components/StaticPageContainers/SectionGrid41';
import SectionGrid31 from '../../components/StaticPageContainers/SectionGrid31';
import SectionSimpleContainer from '../../components/StaticPageContainers/SectionSimpleContainer';
import { useConfiguration } from '../../context/configurationContext';
import { useIntl } from 'react-intl';
import TrustWidgetSmall from '../../components/StaticPageContainers/TrustWidgetSmall';

const HouseSittingUK = props => {

    const faq = [
        {
            question: "Is house sitting popular in the UK?",
            answer: "Yes. House sitting has become increasingly popular across the UK as more homeowners look for trusted, affordable property and pet care. It’s a win-win arrangement where sitters enjoy free accommodation and homeowners gain peace of mind while they travel.",
            linkText: "Find more about ",
            linkAction: "pet care",
            linkUrl: "/petsitting-services",
        },
        {
            question: "Do I need to pay to be a house sitter in the UK?",
            answer: "It’s free to register and browse listings on HouseSit Match, but you’ll need a membership to contact homeowners or apply for sits. Memberships include full access to verified listings, secure messaging and member support."
        },
        {
            question: "Can I house sit in the UK if I’m from another country?",
            answer: "Yes. Many international members house sit in the UK each year. Depending on your nationality and the length of your stay, you may need a standard visitor visa. Always check the latest UK Government guidelines before travelling.",
            linkText: "Find more about ",
            linkAction: "standard visitor visa",
            linkUrl: "/house-sitting-visa",
        },
        {
            question: "Do house sitters get paid in the UK?",
            answer: "Most house sitting arrangements are based on an exchange: free accommodation in return for caring for the home and pets. However, in rare cases, homeowners may offer a small payment for long-term or specialist sits."
        },
        {
            question: "What kinds of homes are available for house sitting in the UK?",
            answer: "Listings vary widely, from London apartments and suburban homes to countryside cottages and coastal properties. Many include pets, so you can choose opportunities that match your preferences and experience."
        },
        {
            question: "How do I find house sitting jobs in the UK?",
            answer: "Simply create a sitter profile, verify your ID and explore available listings across the UK. You can filter by date, location and duration to find sits that fit your plans.",
            linkText: "Explore  ",
            linkAction: "available listings",
            linkUrl: "/search-house-sit",
        },
    ];

    const config = useConfiguration();
    const intl = useIntl();
    const marketplaceName = config.marketplaceName;
    const schemaTitle = intl.formatMessage({ id: 'HouseSittingUK.schemaTitle' }, { marketplaceName });
    const schemaDescription = intl.formatMessage({ id: 'HouseSittingUK.schemaDescription' });

    return (
        <Page
            title={schemaTitle}
            description={schemaDescription}>
            <LayoutSingleColumn
                topbar={<TopbarContainer />}
                footer={<SectionFooter />}
                mainColumnClassName={css.mainColumnClassName}
            >

                <div className={css.root}>

                    <SectionHero
                        imageUrl={LondonWestminsterImage}
                        header={
                            <H3 as="h1">
                                House Sitting in the UK
                            </H3>
                        }
                        content={
                            <>
                                <p className={css.info}>
                                    Discover trusted house sitting opportunities across England, Scotland, Wales and Northern Ireland. Whether you’re a homeowner looking for reliable care or a sitter seeking a new adventure, HouseSit Match connects you with verified members throughout the UK.
                                </p>



                                <div className="rowMobile fitWidth cenSelf gap20">
                                    <NamedLink
                                        className={css.ctaButton}
                                        name="MembershipPlansPage"
                                        params={{ accountType: userTypes.homeowner }}>
                                        Explore Memberships for Homeowners
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>

                                    <NamedLink
                                        className={css.ctaButton}
                                        name="MembershipPlansPage"
                                        params={{ accountType: userTypes.housesitter }}>
                                        Explore Memberships for Sitters
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>
                                </div>

                                <TrustWidgetSmall text={"• Verified members • UK-based support since 2013"} />
                            </>}
                    />


                    <SectionGrid421
                        backgroundColor="white"
                        header={
                            <>
                                <p className={css.sectionTitle}>
                                    Why Choose HouseSit Match for House Sitting in the UK
                                </p>

                                <p className={css.info}>
                                    For more than a decade, HouseSit Match has helped homeowners and sitters connect safely and confidently across the United Kingdom. Our trusted community is built on experience, transparency and genuine care for homes and pets.
                                </p>
                            </>
                        }
                        content={
                            <>
                                <div className={css.card}>
                                    <img src={UkImage} className={css.cardImage} />

                                    <H3>
                                        Trusted UK Network
                                    </H3>
                                    <p className={css.info}>
                                        Thousands of verified members across England, Scotland, Wales and Northern Ireland use HouseSit Match to find reliable care and accommodation.
                                    </p>
                                </div>

                                <div className={css.card}>
                                    <img src={SafeImage} className={css.cardImage} />

                                    <H3>
                                        Safe and Secure Matching
                                    </H3>
                                    <p className={css.info}>
                                        All sitters complete
                                        <NamedLink className={css.link}
                                            name="TrustAndSafetyPage">
                                            ID checks
                                        </NamedLink>, provide references and receive reviews after every sit. Our support team monitors listings to ensure peace of mind for everyone.
                                    </p>
                                </div>

                                <div className={css.card}>
                                    <img src={PersonalImage} className={css.cardImage} />

                                    <H3>
                                        Experienced and Personal Service
                                    </H3>
                                    <p className={css.info}>
                                        As a family-run UK company, we’ve supported our community since 2013 with hands-on help and guidance every step of the way.
                                    </p>
                                </div>

                                <div className={css.card} >
                                    <img src={RatedImage} className={css.cardImage} />

                                    <H3>
                                        Rated Excellent by Members
                                    </H3>
                                    <p className={css.info}>
                                        We’re proud to be rated Excellent on Trustpilot, with a 4.8 / 5 score from nearly 400 reviews, and 4.7 / 5 on Google.
                                    </p>
                                </div>
                            </>
                        }
                        footer={
                            <>
                            </>
                        } />


                    <SectionGrid21
                        style={{ gap: "0 !important" }}
                        header={
                            <>
                                <p className={css.sectionTitle}>
                                    Explore House Sitting Across the UK
                                </p>

                                <p className={css.info}>
                                    From London to the Scottish Highlands, HouseSit Match connects homeowners and sitters in every corner of the United Kingdom. Discover the unique charm of each region and find opportunities that match your lifestyle and travel goals.
                                </p>
                            </>}
                        content={
                            <>
                                <div className={css.overlayParent}>
                                    <img src={EnglandImage} className={css.overlayImage} />
                                    <div className={css.overlayContainer}>
                                        <p className={css.subtitle}>
                                            House Sitting in England
                                        </p>
                                        <p className={css.info}>
                                            England offers the perfect blend of culture, countryside and community. From city apartments in London to cottages in the Cotswolds and family homes in the Lake District, house sitting in England gives you authentic experiences and comfortable stays across the country.
                                        </p>
                                    </div>
                                </div>

                                <div className={css.overlayParent}>
                                    <img src={ScotlandImage} className={css.overlayImage} />
                                    <div className={css.overlayContainer}>
                                        <p className={css.subtitle}>
                                            House Sitting in Scotland
                                        </p>
                                        <p className={css.info}>
                                            Experience Scotland’s dramatic landscapes and welcoming communities. From Edinburgh’s history to the serenity of the Highlands and islands, house sitting in Scotland combines adventure with the comfort of a trusted home.
                                        </p>
                                    </div>
                                </div>

                                <div className={css.overlayParent}>
                                    <img src={WalesImage} className={css.overlayImage} />
                                    <div className={css.overlayContainer}>
                                        <p className={css.subtitle}>
                                            House Sitting in Wales
                                        </p>
                                        <p className={css.info}>
                                            Wales offers a slower pace of life, where coastal towns, castles and national parks create a peaceful setting for every sit. Whether you’re caring for pets near Cardiff or housesitting in the Brecon Beacons, you’ll find friendly homeowners and incredible scenery.
                                        </p>
                                    </div>
                                </div>

                                <div className={css.overlayParent}>
                                    <img src={EnglandImage} className={css.overlayImage} />
                                    <div className={css.overlayContainer}>
                                        <p className={css.subtitle}>
                                            House Sitting in Northern Ireland
                                        </p>
                                        <p className={css.info}>
                                            In Northern Ireland, house sitting connects you to a region full of heritage, warmth and natural beauty. From Belfast’s lively culture to the Giant’s Causeway coastline, every sit offers a chance to experience local life in a truly unique setting.
                                        </p>
                                    </div>
                                </div>


                            </>
                        }
                        footer={<>

                            <div className="col cenV fitWidth cenSelf gap20">
                                <NamedLink
                                    className={css.ctaButton}
                                    name="SearchHouseSitPage" >
                                    View All UK House Sitting Opportunities
                                    <img src={ContinueIcon} className={css.icon} />
                                </NamedLink>
                            </div>
                        </>
                        } />

                    <SectionGrid41
                        backgroundColor="white"
                        header={
                            <>
                                <p className={css.sectionTitle}>
                                    How House Sitting Works in the UK
                                </p>
                                <p className={css.info}>
                                    Getting started with house sitting is simple. Whether you’re a homeowner or sitter, HouseSit Match makes it easy to connect, communicate and build trusted arrangements anywhere in the UK.
                                </p>
                            </>
                        }
                        content={
                            <>
                                <div className={css.stepContainer}>
                                    <H3>
                                        <span class={css.circleNumber}>1</span>
                                        Create Your Free Profile
                                    </H3>
                                    <p className={css.info}>
                                        <NamedLink className={css.link}
                                            name="SignupPage">
                                            Register on HouseSit Match
                                        </NamedLink> and choose a membership that suits your needs as a homeowner or sitter.
                                    </p>
                                </div>
                                <div className={css.stepContainer}>
                                    <H3>
                                        <span class={css.circleNumber}>2</span>
                                        Post or Browse Listings
                                    </H3>
                                    <p className={css.info}>
                                        Homeowners
                                        <NamedLink className={css.link}
                                            name="SearchHouseSitPage">
                                            list their sits
                                        </NamedLink>, and sitters explore opportunities across the UK that match their availability.
                                    </p>
                                </div>
                                <div className={css.stepContainer}>
                                    <H3>
                                        <span class={css.circleNumber}>3</span>
                                        Connect and Confirm
                                    </H3>
                                    <p className={css.info}>
                                        Use our secure platform to message, agree on details and arrange video calls before confirming your sit.
                                    </p>
                                </div>
                                <div className={css.stepContainer}>
                                    <H3>
                                        <span class={css.circleNumber}>4</span>
                                        Enjoy Peace of Mind
                                    </H3>
                                    <p className={css.info}>
                                        Homeowners travel knowing their property and pets are cared for, while sitters enjoy comfortable, trusted stays.
                                    </p>
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <div className="rowMobile fitWidth cenSelf gap20">
                                    <NamedLink
                                        className={css.ctaButton}
                                        name="MembershipPlansPage"
                                        params={{ accountType: userTypes.homeowner }}>
                                        Explore Memberships for Homeowners
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>

                                    <NamedLink
                                        className={css.ctaButton}
                                        name="MembershipPlansPage"
                                        params={{ accountType: userTypes.housesitter }}>
                                        Explore Memberships for Sitters
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>
                                </div>
                            </>
                        } />


                    <SectionGrid421
                        header={
                            <>
                                <p className={css.sectionTitle}>
                                    Benefits of House Sitting in the UK
                                </p>

                                <p className={css.info}>
                                    House sitting isn’t just an affordable way to travel, it’s a trusted exchange that helps homeowners and sitters across the UK enjoy worry-free experiences and lasting connections.
                                </p>
                            </>
                        }
                        content={
                            <>
                                <div className={css.card}>
                                    <H3>
                                        Free, Comfortable Stays
                                    </H3>
                                    <p className={css.info}>
                                        🏠︎ Sitters enjoy unique homes across the UK without the cost of accommodation, from city apartments to country cottages.
                                    </p>
                                </div>
                                <div className={css.card}>
                                    <H3>
                                        Peace of Mind for Homeowners
                                    </H3>
                                    <p className={css.info}>
                                        ✚ Homeowners travel confidently knowing their pets and property are cared for by trusted, verified members.
                                    </p>
                                </div>
                                <div className={css.card}>
                                    <H3>
                                        Cultural and Local Immersion
                                    </H3>
                                    <p className={css.info}>
                                        👤︎ Both sitters and homeowners experience authentic community life, exploring the UK beyond typical tourist paths.
                                    </p>
                                </div>
                                <div className={css.card}>
                                    <H3>
                                        A Community Built on Trust
                                    </H3>
                                    <p className={css.info}>
                                        🤝︎ Every member is ID-checked and reviewed for reliable and safe arrangements.
                                    </p>
                                </div>

                            </>
                        }
                        footer={
                            <>
                                <div className="rowMobile fitWidth cenSelf gap20">
                                    <NamedLink
                                        className={css.ctaButton}
                                        name="BenefitsHomeownersPage" >
                                        Benefits for Homeowners
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>


                                    <NamedLink
                                        className={css.ctaButton}
                                        name="BenefitsHouseSittersPage" >
                                        Benefits for Sitters
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>
                                </div>
                            </>
                        } />


                    <SectionGrid31
                        backgroundColor="white"
                        header={<>
                            <p className={css.sectionTitle}>
                                Trusted by Homeowners and Sitters Across the UK
                            </p>

                            <p className={css.info}>
                                Thousands of members across England, Scotland, Wales and Northern Ireland use HouseSit Match to exchange <NamedLink className={css.link}
                                    name="LandingPage">
                                    trusted house sitting services
                                </NamedLink>. Here’s what some of them have to say.
                            </p>
                        </>}
                        content={<>
                            <div className={css.card}>
                                <img src={AvatarPlaceholder} className={css.reviewerImage} />

                                <p className={css.info}>
                                    “HouseSit Match made the whole process simple and stress free. Our sitter was fantastic and the platform support gave us complete peace of mind while we were away.”
                                </p>
                                <p className={css.reviewer}>
                                    — Emma, Homeowner in Surrey
                                </p>

                            </div>

                            <div className={css.card}>
                                <img src={AvatarPlaceholder} className={css.reviewerImage} />

                                <p className={css.info}>
                                    “I’ve discovered amazing parts of the UK through sits on HouseSit Match. Every homeowner I’ve met has been welcoming, and the verification process helps everyone feel secure.”
                                </p>
                                <p className={css.reviewer}>
                                    — David, House Sitter from Manchester
                                </p>

                            </div>

                            <div className={css.card}>
                                <img src={AvatarPlaceholder} className={css.reviewerImage} />

                                <p className={css.info}>
                                    “We’ve used HouseSit Match several times and always had wonderful sitters. It’s become our go-to platform for reliable help when we travel.”
                                </p>
                                <p className={css.reviewer}>
                                    — Helen, Homeowner in Edinburgh
                                </p>

                            </div>
                        </>}
                        footer={
                            // <div className="row cenV fitWidth cenSelf">
                            //     <TrustWidgetSmall />Google Reviews 4.7/5 from 35 reviews
                            //     {/* ⭐ Trustpilot 4.8/5 from nearly 400 reviews • Google Reviews 4.7/5 from 35 reviews */}
                            //     {/* <a href="https://uk.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener noreferrer">
                            //         Read more reviews on Trustpilot
                            //     </a> */}
                            // </div>
                            <TrustWidgetSmall text={"•  Google Reviews 4.7/5 from 35 reviews"} />
                        } />

                    <SectionSimpleContainer
                        header={
                            <>
                                <p className={css.sectionTitle}>
                                    Start Your House Sitting Journey in the UK
                                </p>
                                <p className={css.info}>
                                    <NamedLink className={css.link}
                                        name="SignupPage">
                                        Join our trusted community
                                    </NamedLink> of homeowners and sitters across the United Kingdom. Whether you want to explore new places or find reliable care for your home and pets, HouseSit Match helps you do it safely and with confidence.
                                </p>
                            </>}
                        footer={<>
                            <div className="rowMobile fitWidth cenSelf gap20">
                                <NamedLink
                                    className={css.ctaButton}
                                    name="SearchHouseSitPage" >
                                    Find House Sitting Opportunities
                                    <img src={ContinueIcon} className={css.icon} />
                                </NamedLink>


                                <NamedLink
                                    className={css.ctaButton}
                                    name="SearchHousesittersRedirect" >
                                    Find a Trusted House Sitter
                                    <img src={ContinueIcon} className={css.icon} />
                                </NamedLink>
                            </div>
                        </>
                        }
                    />


                    <SectionSimpleContainer
                        backgroundColor="white"
                        header={
                            <p className={css.sectionTitle}>
                                FAQs About House Sitting in the UK
                            </p>
                        }
                        content={
                            <CollapseFAQ
                                list={faq}
                            />
                        } />



                </div>

            </LayoutSingleColumn>
        </Page >
    );
};

export default HouseSittingUK;
